import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createTransaction,
  updateTransaction,
} from "../RTK/Features/Transaction/TrnasactionSlice";
import { reSetItemToEdit } from "../RTK/Features/TransactionEdit/TransactionEditSlice";

import FormHeader from "./FormHeader";

function Form() {
  const [name, setName] = React.useState("");
  const [amount, setAmount] = React.useState("");
  const [type, setType] = React.useState("");
  const { itemToEdit } = useSelector((state) => state.transactionEdit);

  React.useEffect(() => {
    const { id, name, type, amount } = itemToEdit;

    if (id) {
      setName(name);
      setAmount(amount);
      setType(type);
    } else {
      setName("");
      setAmount("");
      setType("");
    }
  }, [itemToEdit]);

  const dispatch = useDispatch();

  const handleCancelEdit = () => {
    dispatch(reSetItemToEdit());
  };

  const handleCreate = (e) => {
    e.preventDefault();
    dispatch(
      createTransaction({
        name,
        amount: Number(amount),
        type,
      })
    );

    setAmount("");
    setName("");
    setType("");
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    dispatch(
      updateTransaction({
        id: itemToEdit?.id,
        data: {
          name,
          amount: Number(amount),
          type,
        },
      })
    );
    dispatch(reSetItemToEdit());
    setAmount("");
    setName("");
    setType("");
  };
  const isDisabled = !name || !amount || !type;
  const activeClass = `bg-sky-700	 w-full p-2 text-slate-100 hover:bg-sky-800 active:bg-sky-900`;
  const disabledClass = `bg-slate-300 w-full p-2 text-slate-400`;
  return (
    <div className="flex flex-col items-center justify-center">
      <FormHeader />
      <div className="p-4 h-full w-[400px]">
        <form
          className="w-full h-full"
          onSubmit={itemToEdit.id ? handleUpdate : handleCreate}
        >
          <fieldset className="text-slate-300 p-4 border-slate-300 border-[1px]">
            <legend>Add new transaction:</legend>
            <div className="flex justify-between items-center py-2">
              <label className="w-1/3 text-slate-300" htmlFor="name">
                Name:
              </label>
              <input
                className="w-2/3 focus:outline-0 focus:ring-slate-400 text-slate-900 focus:ring-[2px]"
                type="text"
                id="name"
                name="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="flex justify-between items-center py-4">
              <div>
                <label className="text-slate-300" htmlFor="type">
                  Type:
                </label>
              </div>
              <div className="w-2/3 flex gap-12">
                <div>
                  <input
                    type="radio"
                    id="income"
                    name="type"
                    checked={type === "income"}
                    onChange={() => setType("income")}
                  />
                  <label htmlFor="income" className="text-slate-300">
                    Income
                  </label>
                </div>
                <div>
                  <input
                    type="radio"
                    id="expense"
                    name="type"
                    checked={type === "expense"}
                    onChange={() => setType("expense")}
                  />
                  <label htmlFor="expense" className="text-slate-300">
                    Expense
                  </label>
                </div>
              </div>
            </div>

            <div className="flex justify-between items-center py-4">
              <label className="w-1/3 text-slate-300" htmlFor="amount">
                Amount:
              </label>
              <input
                className="w-2/3 focus:outline-0 focus:ring-slate-400 text-slate-900 focus:ring-[2px]"
                type="number"
                id="amount"
                name="amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </div>

            <div className="flex justify-between items-center py-4 w-full gap-6">
              {itemToEdit.id ? (
                <>
                  <button
                    className={isDisabled ? disabledClass : activeClass}
                    type="submit"
                    disabled={isDisabled}
                  >
                    Update Transaction
                  </button>
                  <button
                    className="bg-red-500 w-full p-2 text-slate-100 hover:bg-red-600 active:bg-red-700"
                    onClick={handleCancelEdit}
                  >
                    Cancel
                  </button>
                </>
              ) : (
                <button
                  className={isDisabled ? disabledClass : activeClass}
                  type="submit"
                  disabled={isDisabled}
                >
                  Add Transaction
                </button>
              )}
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  );
}

export default Form;
